import { StateType } from "./types"

export {
  GRAPHIK_MEDIUM_WEB_BASE64 as FONT_GRAPHIK_MEDIUM_WEB_BASE64, 
  GRAPHIK_REGULAR_WEB_BASE64 as FONT_GRAPHIK_REGULAR_WEB_BASE64 
} from "./_fonts"

export const LOCAL_FORAGE_KEY = "hs--interviewBuilder--cachedData"

export enum ACTIONS {
  ADD_NEW_QUESTION = "ADD_NEW_QUESTION",
  ADD_QUESTION_TO_INTERVIEW = "ADD_QUESTION_TO_INTERVIEW",
  LOAD_STATE = "LOAD_STATE",
  MOVE_QUESTION_IN_INTERVIEW = "MOVE_QUESTION_IN_INTERVIEW",
  PERMANENTLY_DELETE_QUESTION = "PERMANENTLY_DELETE_QUESTION",
  REMOVE_QUESTION_FROM_INTERVIEW = "REMOVE_QUESTION_FROM_INTERVIEW",
  RESET_STATE = "RESET_STATE",
  REVERT_QUESTION_EDITED_TEXT = "REVERT_QUESTION_EDITED_TEXT",
  START_DRAGGING_QUESTION = "START_DRAGGING_QUESTION",
  STOP_DRAGGING_QUESTION = "STOP_DRAGGING_QUESTION",
  STOP_EDITING_QUESTION = "STOP_EDITING_QUESTION",
  TOGGLE_EDITING_QUESTION = "TOGGLE_EDITING_QUESTION",
  UPDATE_DROP_ZONE_INDEX = "UPDATE_DROP_ZONE_INDEX",
  UPDATE_QUESTION_EDITED_TEXT = "UPDATE_QUESTION_EDITED_TEXT",
  UPDATE_JOB_TITLE_FIELD = "UPDATE_JOB_TITLE_FIELD",
  EXPORT_TO_PDF = "EXPORT_TO_PDF",
}

export enum QUESTION_LIST_VARIANTS {
  LIBRARY = "LIBRARY",
  INTERVIEW = "INTERVIEW",
}

export enum STATE_PRESETS {
  DEFAULT = "DEFAULT",
  CUSTOMER_SERVICE_MANAGER = "CUSTOMER_SERVICE_MANAGER",
  CUSTOMER_SUCCESS_MANAGER = "CUSTOMER_SUCCESS_MANAGER",
  CUSTOMER_SUPPORT_ENGINEER = "CUSTOMER_SUPPORT_ENGINEER",
  CUSTOMER_SUPPORT_REPRESENTATIVE = "CUSTOMER_SUPPORT_REPRESENTATIVE",
  PRODUCT_SUPPORT_ANALYST = "PRODUCT_SUPPORT_ANALYST",
  SUPPORT_OPERATIONS_MANAGER = "SUPPORT_OPERATIONS_MANAGER",
  TECHNICAL_SUPPORT_SPECIALIST = "TECHNICAL_SUPPORT_SPECIALIST",
}

export const STATE_PRESETS_TITLES: { [k in STATE_PRESETS]: string } = {
  DEFAULT: "",
  CUSTOMER_SERVICE_MANAGER: "Customer Service Manager",
  CUSTOMER_SUCCESS_MANAGER: "Customer Success Manager",
  CUSTOMER_SUPPORT_ENGINEER: "Customer Support Engineer",
  CUSTOMER_SUPPORT_REPRESENTATIVE: "Customer Support Representative",
  PRODUCT_SUPPORT_ANALYST: "Product Support Analyst",
  SUPPORT_OPERATIONS_MANAGER: "Support Operations Manager",
  TECHNICAL_SUPPORT_SPECIALIST: "Technical Support Specialist",
}

const DEFAULT_STATE: StateType = {
  questions: {
    "2": {
      "category": "Competency",
      "role": "All",
      "textDefault": "How would you define good customer service?",
      "id": "2",
      "textEdited": ""
    },
    "3": {
      "category": "Contribution",
      "role": "Customer Success Specialist",
      "textDefault": "What appeals to you about this role?",
      "id": "3",
      "textEdited": ""
    },
    "4": {
      "category": "Competency",
      "role": "All",
      "textDefault": "What’s the best customer service you’ve ever received? Why?",
      "id": "4",
      "textEdited": ""
    },
    "5": {
      "category": "Competency",
      "role": "Customer Service Manager",
      "textDefault": "Can you tell me about a time when you received poor customer service?",
      "id": "5",
      "textEdited": ""
    },
    "6": {
      "category": "Behavioral",
      "role": "All",
      "textDefault": "Is there a difference between customer service and customer support?",
      "id": "6",
      "textEdited": ""
    },
    "7": {
      "category": "Behavioral",
      "role": "All",
      "textDefault": "Can you tell me about a time when you were proud of the level of service you gave a customer?",
      "id": "7",
      "textEdited": ""
    },
    "8": {
      "category": "Behavioral",
      "role": "All",
      "textDefault": "Have you ever dealt with an unreasonable customer? How did you handle it, and how would you handle it today?",
      "id": "8",
      "textEdited": ""
    },
    "9": {
      "category": "Behavioral",
      "role": "All",
      "textDefault": "Have you ever bent the rules in assisting a customer? Tell me about the situation and the outcome.",
      "id": "9",
      "textEdited": ""
    },
    "10": {
      "category": "Behavioral",
      "role": "All",
      "textDefault": "In your past work, have you ever received negative feedback from a customer? What did you do with that feedback?",
      "id": "10",
      "textEdited": ""
    },
    "11": {
      "category": "Behavioral",
      "role": "All",
      "textDefault": "Can you tell me about a customer who you found difficult to understand and how you approached that interaction?",
      "id": "11",
      "textEdited": ""
    },
    "12": {
      "category": "Behavioral",
      "role": "All",
      "textDefault": "Can you describe a time when you had to say no to an important customer’s request?",
      "id": "12",
      "textEdited": ""
    },
    "13": {
      "category": "Situational",
      "role": "All",
      "textDefault": "What’s the best way to help a customer who has worked with multiple agents and hasn’t received the help they need?",
      "id": "13",
      "textEdited": ""
    },
    "14": {
      "category": "Behavioral",
      "role": "All",
      "textDefault": "Tell me about a time when a customer was reporting a technical issue that you didn’t know the answer to. What was your approach, and how did it end up?",
      "id": "14",
      "textEdited": ""
    },
    "15": {
      "category": "Behavioral",
      "role": "All",
      "textDefault": "Can you tell me about a situation with a customer when there wasn’t a clear policy to use and you needed to make a judgment call? How did you approach your decision, and what happened?",
      "id": "15",
      "textEdited": ""
    },
    "16": {
      "category": "Behavioral",
      "role": "All",
      "textDefault": "Can you give me an example of a situation where there were major problems with your product/service and you needed to respond without having all the answers yet?",
      "id": "16",
      "textEdited": ""
    },
    "17": {
      "category": "Behavioral",
      "role": "All",
      "textDefault": "Can you give an example of how you handled alerting a customer when your product/service caused a major problem?",
      "id": "17",
      "textEdited": ""
    },
    "18": {
      "category": "Situational",
      "role": "All",
      "textDefault": "When responding to a customer, how do you decide what information to include and what to leave out?",
      "id": "18",
      "textEdited": ""
    },
    "19": {
      "category": "Behavioral",
      "role": "All",
      "textDefault": "Can you tell me about a time when you needed to convince a customer or teammate to change the way they were working (e.g., adopt a new procedure or modify their language) and how you went about doing so?",
      "id": "19",
      "textEdited": ""
    },
    "20": {
      "category": "Contribution",
      "role": "All",
      "textDefault": "What’s the last new skill you learned? Why did you choose that skill, and how did you learn it?",
      "id": "20",
      "textEdited": ""
    },
    "21": {
      "category": "",
      "role": "All",
      "textDefault": "Can you tell me about a time when you made a great contribution to your team?",
      "id": "21",
      "textEdited": ""
    },
    "22": {
      "category": "Contribution",
      "role": "All",
      "textDefault": "What’s the next book I should read? Why?",
      "id": "22",
      "textEdited": ""
    },
    "23": {
      "category": "Contribution",
      "role": "All",
      "textDefault": "What are you better at today than you were this time last year?",
      "id": "23",
      "textEdited": ""
    },
    "24": {
      "category": "Contribution",
      "role": "All",
      "textDefault": "What do you think makes a good teammate?",
      "id": "24",
      "textEdited": ""
    },
    "25": {
      "category": "Situational",
      "role": "All",
      "textDefault": "Is there an aspect of customer support that you think is overrated/underrated? ",
      "id": "25",
      "textEdited": ""
    },
    "26": {
      "category": "Competency",
      "role": "Customer Service Manager",
      "textDefault": "How would you go about prioritizing different customer requests for your company to consider?",
      "id": "26",
      "textEdited": ""
    },
    "27": {
      "category": "Competency",
      "role": "",
      "textDefault": "What skills do you think are necessary to be a good support agent?",
      "id": "27",
      "textEdited": ""
    },
    "28": {
      "category": "Situational",
      "role": "",
      "textDefault": "How can you explain a complex idea in simple terms?",
      "id": "28",
      "textEdited": ""
    },
    "29": {
      "category": "Competency",
      "role": "",
      "textDefault": "What do you think is more important, a fast answer or a thorough one? Why do you think that?",
      "id": "29",
      "textEdited": ""
    },
    "30": {
      "category": "Competency",
      "role": "",
      "textDefault": "Tell us about the types of questions, issues, and problems you’re dealing with on a daily basis. What general groups do those requests fall into? ",
      "id": "30",
      "textEdited": ""
    },
    "31": {
      "category": "Competency",
      "role": "",
      "textDefault": "What tools and resources do you regularly use to solve your most complex (or technical) problems?",
      "id": "31",
      "textEdited": ""
    },
    "32": {
      "category": "Contribution",
      "role": "",
      "textDefault": "What will best support your success in this role? What do you think you’ll need to do in order to  overcome these challenges?",
      "id": "32",
      "textEdited": ""
    },
    "33": {
      "category": "Situational",
      "role": "",
      "textDefault": "Customer support work often requires a lot of empathy to meet a variety of customers where they’re at. How do you approach meeting different types of customers with empathy?",
      "id": "33",
      "textEdited": ""
    },
    "34": {
      "category": "Contribution",
      "role": "",
      "textDefault": " In your experience, what characteristics make someone effective in a support role? Are there any that you feel particularly strong about?",
      "id": "34",
      "textEdited": ""
    },
    "35": {
      "category": "Contribution",
      "role": "",
      "textDefault": "What keeps you engaged with doing this type of work every day? What challenges have you experienced and how do you overcome them?",
      "id": "35",
      "textEdited": ""
    },
    "36": {
      "category": "Contribution",
      "role": "",
      "textDefault": "A year from now, what do you hope is true about your professional development? What will you have been proud of accomplishing? ",
      "id": "36",
      "textEdited": ""
    },
    "37": {
      "category": "Situational",
      "role": "",
      "textDefault": "Describe how you would respond to a complaint about your company's customer service that was posted on social media.",
      "id": "37",
      "textEdited": ""
    },
    "38": {
      "category": "Competency",
      "role": "",
      "textDefault": "Why do you think customers choose to buy from our company?",
      "id": "38",
      "textEdited": ""
    },
    "39": {
      "category": "Behavioral",
      "role": "",
      "textDefault": "What's a favorite customer service story you always tell other people?",
      "id": "39",
      "textEdited": ""
    },
    "40": {
      "category": "Behavioral",
      "role": "",
      "textDefault": "Have you had to tell a customer they were wrong? How did you approach that conversation?",
      "id": "40",
      "textEdited": ""
    },
    "41": {
      "category": "Behavioral",
      "role": "",
      "textDefault": "Have you ever had to move customers from one customer service channel to another in order to help them? How did you do it?",
      "id": "41",
      "textEdited": ""
    },
    "42": {
      "category": "Contribution",
      "role": "",
      "textDefault": "Do you have any techniques for getting through difficult days at work?",
      "id": "42",
      "textEdited": ""
    },
    "43": {
      "category": "Behavioral",
      "role": "",
      "textDefault": "Have you ever had to improvise to help a customer? Tell me what happened.",
      "id": "43",
      "textEdited": ""
    },
    "44": {
      "category": "Behavioral",
      "role": "",
      "textDefault": "Can you tell me about a time you made a mistake at work, and what happened next?",
      "id": "44",
      "textEdited": ""
    },
    "45": {
      "category": "Competency",
      "role": "",
      "textDefault": "How do you approach your work day when there is more work than you can possibly get done?",
      "id": "45",
      "textEdited": ""
    },
    "46": {
      "category": "Contribution",
      "role": "",
      "textDefault": "What is your preferred way of receiving feedback?",
      "id": "46",
      "textEdited": ""
    },
    "47": {
      "category": "Competency",
      "role": "",
      "textDefault": "What does \"customer satisfaction\" mean to you?",
      "id": "47",
      "textEdited": ""
    },
    "48": {
      "category": "Contribution",
      "role": "",
      "textDefault": "Describe the team structures have you worked in previously. Which one did you like best, and why?",
      "id": "48",
      "textEdited": ""
    },
    "49": {
      "category": "Behavioral",
      "role": "",
      "textDefault": "Have you ever disagreed with a company policy or decision? Tell me about what happened and how you responded.",
      "id": "49",
      "textEdited": ""
    },
    "50": {
      "category": "Competency",
      "role": "",
      "textDefault": "Do you think good service can help a company beat their competitors? If so, how?",
      "id": "50",
      "textEdited": ""
    },
    "51": {
      "category": "Behavioral",
      "role": "",
      "textDefault": "Tell me about a time you had to be flexible at work.",
      "id": "51",
      "textEdited": ""
    },
    "52": {
      "category": "Situational",
      "role": "",
      "textDefault": " How do you help different types of customers with empathy?",
      "id": "52",
      "textEdited": ""
    },
    "53": {
      "category": "Behavioral",
      "role": "",
      "textDefault": "Would you ever re-write a prepared (correct) answer to explain the same information differently for a given customer? When might you do it?",
      "id": "53",
      "textEdited": ""
    },
    "54": {
      "category": "Contribution",
      "role": "",
      "textDefault": "What is your favorite part of your current role? What is your least favorite? Why?",
      "id": "54",
      "textEdited": ""
    },
    "55": {
      "category": "Contribution",
      "role": "",
      "textDefault": "What do you want to do differently in your next role? Why?",
      "id": "55",
      "textEdited": ""
    },
    "56": {
      "category": "Contribution",
      "role": "",
      "textDefault": "What are the top 3 things you’re looking for in your next role/company/team?",
      "id": "56",
      "textEdited": ""
    },
    "57": {
      "category": "Behavioral",
      "role": "",
      "textDefault": "Tell me about a time you went out of your way to be helpful to someone inside your company?",
      "id": "57",
      "textEdited": ""
    },
    "58": {
      "category": "Contribution",
      "role": "",
      "textDefault": "Who is the best person you ever collaborated with at work? Why?",
      "id": "58",
      "textEdited": ""
    },
    "59": {
      "category": "Contribution",
      "role": "",
      "textDefault": "Tell me about the best manager you’ve ever had in your career. What made them great to work with?",
      "id": "59",
      "textEdited": ""
    },
    "60": {
      "category": "Contribution",
      "role": "",
      "textDefault": "What is the most useful feedback you have received from a manager? What did you learn?",
      "id": "60",
      "textEdited": ""
    },
    "61": {
      "category": "Contribution",
      "role": "",
      "textDefault": "Can you tell me about an opinion or belief you had that has changed recently? What made it change?",
      "id": "61",
      "textEdited": ""
    },
    "62": {
      "category": "Contribution",
      "role": "",
      "textDefault": "Of all your past colleagues, who do you most admire? Why?",
      "id": "62",
      "textEdited": ""
    },
    "63": {
      "category": "Behavioral",
      "role": "",
      "textDefault": "Have you ever successfully advocated for a change to a process or policy? How did you make it happen?",
      "id": "63",
      "textEdited": ""
    },
    "64": {
      "category": "Contribution",
      "role": "All",
      "textDefault": "If you had to move to another department in the company, which would you choose? Why?",
      "id": "64",
      "textEdited": ""
    },
    "65": {
      "category": "Competency",
      "role": "",
      "textDefault": "What do you think are the best ways to measure customer service quality?",
      "id": "65",
      "textEdited": ""
    },
    "66": {
      "category": "Situational",
      "role": "",
      "textDefault": "What are the most frustrating things about being in customer service?",
      "id": "66",
      "textEdited": ""
    },
  },
  categories: {},
  categoryIds: [],
  interview: {
    jobTitle: STATE_PRESETS_TITLES.DEFAULT,
    questions: [],
  },
  isDraggingData: {
    cardClientRect: undefined,
    dropZoneIndex: undefined,
    questionId: undefined,
    questionIndex: undefined,
    questionOrigin: undefined,
  }
}

// TODO: !!! All of the preset states need to have the final question IDs listed below
export const STATES: { [key in STATE_PRESETS]: StateType } = {
  DEFAULT: DEFAULT_STATE,
  CUSTOMER_SERVICE_MANAGER: {
    ...DEFAULT_STATE,
    interview: {
      ...DEFAULT_STATE.interview,
      questions: ["53", "32", "27", "12", "13", "19", "25", "26", "34", "40", "44", "48"],
      jobTitle: STATE_PRESETS_TITLES.CUSTOMER_SERVICE_MANAGER,
    }
  },
  CUSTOMER_SUCCESS_MANAGER: {
    ...DEFAULT_STATE,
    interview: {
      ...DEFAULT_STATE.interview,
      questions: ["26", "19", "18", "17", "14", "6", "7", "10", "12", "25", "28", "32"],
      jobTitle: STATE_PRESETS_TITLES.CUSTOMER_SUCCESS_MANAGER,
    }
  },
  CUSTOMER_SUPPORT_ENGINEER: {
    ...DEFAULT_STATE,
    interview: {
      ...DEFAULT_STATE.interview,
      questions: ["4", "6", "43", "45", "49", "50", "52", "55", "31", "29", "25", "18"],
      jobTitle: STATE_PRESETS_TITLES.CUSTOMER_SUPPORT_ENGINEER,

    }
  },
  CUSTOMER_SUPPORT_REPRESENTATIVE: {
    ...DEFAULT_STATE,
    interview: {
      ...DEFAULT_STATE.interview,
      questions: ["50", "4", "5", "7", "8", "11", "15", "21", "24", "47", "56", "60"],
      jobTitle: STATE_PRESETS_TITLES.CUSTOMER_SUPPORT_REPRESENTATIVE,
    }
  },
  PRODUCT_SUPPORT_ANALYST: {
    ...DEFAULT_STATE,
    interview: {
      ...DEFAULT_STATE.interview,
      questions: ["6", "11", "19", "20", "24", "26", "30", "36", "38", "46", "54", "64"],
      jobTitle: STATE_PRESETS_TITLES.PRODUCT_SUPPORT_ANALYST,
    }
  },
  SUPPORT_OPERATIONS_MANAGER: {
    ...DEFAULT_STATE,
    interview: {
      ...DEFAULT_STATE.interview,
      questions: ["2", "3", "34", "17", "19", "20", "31", "35", "43", "49", "58", "63"],
      jobTitle: STATE_PRESETS_TITLES.SUPPORT_OPERATIONS_MANAGER,
    }
  },
  TECHNICAL_SUPPORT_SPECIALIST: {
    ...DEFAULT_STATE,
    interview: {
      ...DEFAULT_STATE.interview,
      questions: ["4", "6", "8", "9", "11", "14", "17", "20", "23", "34", "41", "44"],
      jobTitle: STATE_PRESETS_TITLES.TECHNICAL_SUPPORT_SPECIALIST,
    }
  },
}

export enum GA_CUSTOM_EVENTS {
  SELECT_PRESET_INTERVIEW = "SELECT_PRESET_INTERVIEW",
  SELECT_CUSTOM_INTERVIEW = "SELECT_CUSTOM_INTERVIEW",
  SELECT_HERO_TAB = "SELECT_HERO_TAB",
  CREATE_INTERVIEW_FOR_ROLE = "CREATE_INTERVIEW_FOR_ROLE",
  DOWNLOAD_JOB_DESCRIPTION = "DOWNLOAD_JOB_DESCRIPTION",
  DOWNLOAD_INTERVIEWING_GUIDE = "DOWNLOAD_INTERVIEWING_GUIDE",
  CLICK_EXPORT_INTERVIEW = "CLICK_EXPORT_INTERVIEW",
  SELECT_EXPORT_PDF = "SELECT_EXPORT_PDF",
  SELECT_COPY_TO_CLIPBOARD = "SELECT_COPY_TO_CLIPBOARD",
  SELECT_RESET_INTERVIEW = "SELECT_RESET_INTERVIEW",
  CONFIRM_RESET_INTERVIEW = "CONFIRM_RESET_INTERVIEW",
  FILTER_QUESTION_LIBRARY = "FILTER_QUESTION_LIBRARY",
  ADD_QUESTION_TO_YOUR_INTERVIEW = "ADD_QUESTION_TO_YOUR_INTERVIEW",
  DRAGGED_QUESTION_TO_YOUR_INTERVIEW = "DRAGGED_QUESTION_TO_YOUR_INTERVIEW",
  DRAGGED_QUESTION_TO_LIBRARY = "DRAGGED_QUESTION_TO_LIBRARY",
}
